<div id="academy-courses" class="page-layout simple">
<!-- CONTENT HEADER -->
<div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
    <button mat-icon-button class="mr-16" [routerLink]="'/'+url">
            <mat-icon>arrow_back</mat-icon>
    </button>
    <h2 class="m-0">{{'LANDINFOCUS.WIZARD.TFOCUS' | translate}}</h2>
</div>



<div class="content p-24">
  <div fxLayout="column" fxLayoutAlign="center">
    <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" >

      <ng-container *ngIf="cargando">
        <div fxFlex="100" fxFlex.gt-sm="33" fxLayout="column" fxLayoutAlign="center stretch" >
          <div fxLayout="column" fxLayoutAlign="space-between center" >
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h2>{{'LANDINFOCUS.WIZARD.CARGANDOF' | translate}}</h2>
          </div>
        </div>
      </ng-container>

  <ng-container *ngIf="!cargando">

    <mat-table [dataSource]="mostrarEncuestasFocus3" class="mat-elevation-z8 " fxFlex="100">
      <!-- <ng-container matColumnDef="validacion">
        <mat-header-cell *matHeaderCellDef>Validación</mat-header-cell>
        <mat-cell *matCellDef="let element">
            <mat-slide-toggle (change)="setValidarEncuesta($event,element._id,element.nombre)" [checked]="element.statusEncuesta"></mat-slide-toggle>
        </mat-cell>
      </ng-container> -->
      <ng-container matColumnDef="nameEncuesta">
        <mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.TABLACAMPOS.NAME' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element"  >
          <ng-container *ngIf="element.idCertificar == EditRowID">
          <mat-form-field appearance="outline" fxFlex="100">
              <input matInput  [(ngModel)]="element.nameSurvey" (blur)="editNameSurvey($event,element.idCertificar)">
          </mat-form-field>
          </ng-container>
          <ng-container *ngIf="element.idCertificar != EditRowID" >
          <div class="" (click)="edit(element.idCertificar,element.nameSurvey)">
            {{element.nameSurvey}}
          </div>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaInicio">
        <mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.TABLACAMPOS.FECHAI' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.fechaLanzamiento }} </mat-cell>
        <!-- <mat-cell *matCellDef="let element"> {{element.fechaInicio |date:"fullDate":'':idiomaActual}} </mat-cell> -->
      </ng-container>

      <ng-container matColumnDef="fechaCerrar">
        <mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.TABLACAMPOS.FECHAF'| translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.fechaLanzamiento}} </mat-cell>
        <!-- <mat-cell *matCellDef="let element"> {{element.fechaCierre |date:"fullDate":'':idiomaActual}} </mat-cell> -->
      </ng-container>


      <!-- <ng-container matColumnDef="avance">
        <mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.TABLACAMPOS.AVANCE' | translate}}</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.vivo}} </mat-cell>
      </ng-container> -->


      <ng-container matColumnDef="estado" >
        <mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.TABLACAMPOS.ESTADO' | translate}}</mat-header-cell>
          <!-- <mat-cell *matCellDef="let element" >
            <ng-container *ngIf="element.estatusVerificacion==1">
            {{'LANDINFOCUS.STATUS-ENCUESTA.'+ element.estatusVerificacion | translate}}
            </ng-container >
            <ng-container *ngIf="element.estatusVerificacion==6">
            requiere validacion
            </ng-container >
            <ng-container *ngIf="element.estatusVerificacion==2">
            {{'LANDINFOCUS.STATUS-ENCUESTA.'+ element.estatusVerificacion | translate}}
            </ng-container >
            <ng-container *ngIf="element.estatusVerificacion==4">
              {{'LANDINFOCUS.STATUS-ENCUESTA.'+ element.estatusVerificacion | translate}}
            </ng-container >
            <ng-container *ngIf="element.estatusVerificacion==5">
               {{'LANDINFOCUS.STATUS-ENCUESTA.'+ element.estatusVerificacion | translate}}
            </ng-container >

          </mat-cell> -->
          <mat-cell *matCellDef="let element" >
               {{'LANDINFOCUS.STATUS-ENCUESTA.'+ 2 | translate}}
      </mat-cell>
      </ng-container>

      <ng-container matColumnDef="accion">
          <mat-header-cell *matHeaderCellDef>{{'LANDINFOCUS.TABLACAMPOS.ACCION' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="p-20" fxLayout="row" fxLayoutAlign="start center">
              <ng-container>
                  <!-- <button mat-mini-fab  class="mr-20" color="warn"  matTooltip="{{'LANDINFOCUS.WIZARD.DELETE' | translate}}"> -->
                  <button mat-mini-fab  class="mr-20" color="warn" (click)="eliminarEncuesta(element.idCertificar);" matTooltip="{{'LANDINFOCUS.WIZARD.DELETE' | translate}}">
                <mat-icon>delete_forever</mat-icon>
              </button>
              <!-- <ng-container *ngIf="element.estatusVerificacion==2 || element.estatusVerificacion==5">
                <button mat-mini-fab  class="mr-20" matTooltip="{{'LANDINFOCUS.WIZARD.VERIPRE' | translate}}"  color="warn" (click)="navigateToEncuestas('companies/detail/:id/control-encuesta/preview-encuestas',element._id)">
                <mat-icon>visibility</mat-icon>
              </button>
              </ng-container>
              <ng-container *ngIf="element.estatusVerificacion==3">
                <button mat-mini-fab  class="mr-20" matTooltip="{{'LANDINFOCUS.WIZARD.TITUTAUTORIZADA' | translate}}"  color="accent" (click)="navigateToEncuestas('companies/detail/:id/control-encuesta/preview-encuestas',element._id)">
                <mat-icon>check_circle_outline</mat-icon>
              </button>
              </ng-container>
              <ng-container *ngIf="element.estatusVerificacion==3">
                <button mat-mini-fab  class="mr-20" matTooltip="{{'LANDINFOCUS.WIZARD.TITUTNOAUTORIZADA' | translate}}"  color="warn" >
                <mat-icon>remove_circle </mat-icon>
              </button>
              </ng-container> -->
              </ng-container>


          </mat-cell>
      </ng-container>



      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>


    </mat-table>
    <div class="mt-20" fxLayout="row" fxLayoutAlign="end center" fxFlex="100">
<div class="" fxLayout="row" fxLayoutAlign="end center" >

      <h2 class="pr-20">{{'LANDINFOCUS.WIZARD.CREARENC' | translate}}</h2>
      <button mat-fab color="primary" aria-label="agregaPreg" (click)="openDialogCreaEncues();" >
      <mat-icon>add</mat-icon>

    </button>
    </div>
    </div>
  </ng-container>
</div>
</div>
